/* global debounce, trapFocus */

if (!customElements.get('line-comment')) {
  class LineComment extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.clearBtn = this.querySelector('#clearButton');
      this.handleClearClick = this.handleClearClick.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.btn = this.querySelector("button");
      this.inputContainer = this.querySelector(".input-container");

      this.debouncedHandleChange = debounce(this.handleChange, 300);

      this.listenerOptions = { capture: true };
    }

    connectedCallback() {
      if (this.input) {
        this.input.addEventListener('change', this.debouncedHandleChange, this.listenerOptions);
      }

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', this.handleClearClick);
      }

      if(this.btn){
        this.btn.addEventListener("click", this.handleClick)
      }
    }

    disconnectedCallback() {
      if (this.input) {
        this.input.removeEventListener('change', this.debouncedHandleChange, this.listenerOptions);
      }

      if (this.clearBtn) {
        this.clearBtn.removeEventListener('click', this.handleClearClick);
      }

      if(this.btn){
        this.btn.addEventListener("click", this.handleClick)
      }
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.inputContainer) {
        this.btn.setAttribute('hidden', ''); 
        this.inputContainer.removeAttribute('hidden');
        this.input.focus();
      }
    }

    handleClearClick(event) {
      event.preventDefault();
      event.stopPropagation();

      console.log('clear button clicked', { target: event.target, thisEl: this });

      if (this.input) {
        this.input.value = '';
        const index = this.input.dataset.index;
        const name = this.input.name || 'comment';
        this.updateLineItemProp(index, name, '');
      }

      if (this.inputContainer) {
        this.btn.removeAttribute('hidden'); 
        this.inputContainer.setAttribute('hidden', "");
      }
    }

    async handleChange(event) {
      event.stopImmediatePropagation?.();
      event.stopPropagation?.();
      event.preventDefault?.();

      const index = event.target.dataset.index;
      const name = event.target.name || 'comment';
      const value = event.target.value;

      await this.updateLineItemProp(index, name, value);
    }

    async updateLineItemProp(index, name, value) {
      const lineIndex = parseInt(index, 10);
      if (Number.isNaN(lineIndex)) {
        console.warn('Invalid line index:', index);
        return;
      }

      const data = {
        line: lineIndex,
        properties: { [name]: value }
      };

      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });

        if (!res.ok) throw new Error('Failed to update cart');

        value ? this.clearBtn.removeAttribute('hidden') : this.clearBtn.setAttribute('hidden', "");
        
      } catch (err) {
        console.error('Error updating comment:', err);
      }
    }

    // async updateLineItemProp(index, name, value) {
    //   const lineIndex = parseInt(index, 10);
    //   if (Number.isNaN(lineIndex)) {
    //     console.warn('Invalid line index:', index);
    //     return;
    //   }

    //   // Get current cart
    //   const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
    //   const cart = await cartRes.json();

    //   const lineItem = cart.items[lineIndex - 1]; // Shopify is 1-based index
    //   if (!lineItem) return;

    //   // Clone current properties
    //   const updatedProperties = { ...lineItem.properties };

    //   if (!value) {
    //     delete updatedProperties[name]; // REMOVE property
    //   } else {
    //     updatedProperties[name] = value;
    //   }

    //   const data = {
    //     line: lineIndex,
    //     properties: updatedProperties
    //   };

    //   try {
    //     const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify(data)
    //     });

    //     if (!res.ok) throw new Error('Failed to update cart');

    //     value
    //       ? this.clearBtn.removeAttribute('hidden')
    //       : this.clearBtn.setAttribute('hidden', "");

    //   } catch (err) {
    //     console.error('Error updating comment:', err);
    //   }
    // }
  }

  customElements.define('line-comment', LineComment);
}


if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');
      this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      this.currentQuantities = [];
      this.querySelectorAll('.cart-item').forEach((item) => {
        const variantId = item.dataset.variantId;
        const quantity = Number(item.querySelector('.qty-input__input').value);
        const affirmEligible = item.dataset.affirmEligible === "true";
        this.currentQuantities[variantId] = quantity;
      });

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', debounce(this.handleChange.bind(this)));
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.js-remove-item')) return;

      evt.preventDefault();
      
      this.updateQuantity(evt.target.dataset.index, 0).then(() => {
        this.updateAffirmBadge();
      });
    }

    updateAffirmBadge() {
      const affirmBadgeEl = document.querySelector("#affirm_eligible");
      if (!affirmBadgeEl) return;

      const cartItems = Array.from(document.querySelectorAll(".cart-item"));
      const totalItemCount = cartItems.length;

      
      if (totalItemCount === 0) {
        affirmBadgeEl.querySelector("input").value = "false";
        const badgeContainer = affirmBadgeEl.querySelector(".product-label-container");
        if (badgeContainer) badgeContainer.hidden = true;
        return;
      }
      
      const allEligible = cartItems.every(item => item.dataset.affirmEligible === "true");
      // console.log(allEligible);
      affirmBadgeEl.querySelector("input").value = allEligible ? "true" : "false";
      const badgeContainer = affirmBadgeEl.querySelector(".product-label-container");
      if (badgeContainer) badgeContainer.hidden = !allEligible;
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      if(evt.target.classList.contains('cart-line-property')) return;
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      this.enableLoading(line);

      // clear all errors except this line's (which will be refreshed after this update)
      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      const sections = this.getSectionsToRender().map((section) => section.section);
      this.fetchRequestOpts.body = JSON.stringify({
        line,
        quantity,
        sections: [...new Set(sections)],
        sections_url: window.location.pathname
      });

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);
        const variantId = Number(lineItem.dataset.variantId);
        const oldTotalQuantity = this.currentTotalItemCount;
        const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        if (this.cartDrawer) {
          cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          // We're on the Cart page
          const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartContent = document.getElementById('cart-summary-and-blocks');
          if (cartContent) cartContent.hidden = true;
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
          if(BSS_B2B) {
            BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();
          }
        });

        if (this.cartDrawer && newTotalQuantity === 0) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions();
        this.setFocus(line, newTotalQuantity, name);
        this.dataset.empty = newTotalQuantity === 0;
        this.currentTotalItemCount = newTotalQuantity;

        // Fire the on:line-item:change event if the line item quantity has changed
        if (oldTotalQuantity !== newTotalQuantity) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              variantId,
              oldQuantity: this.currentQuantities[variantId],
              newQuantity: Number(quantity)
            }
          }));
        }

        this.currentQuantities[variantId] = Number(quantity);

        lineErrors.innerHTML = '';
        lineErrors.hidden = true;
      } catch (error) {
        if (/^[0-9]+$/.test(error.message)) {
          lineErrors.textContent = theme.strings.cartError;
        } else {
          lineErrors.textContent = error.message;
        }
        lineErrors.hidden = false;
        console.log(error); // eslint-disable-line

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

        const input = document.getElementById(`quantity-${line}`);
        input.value = input.dataset.initialValue;
        input.closest('quantity-input').currentQty = input.dataset.initialValue;
      } finally {
        this.classList.remove('pointer-events-none');

        // Attempt to maintain the same scroll position in the cart drawer
        if (cartDrawerContent) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refresh() {
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(true);
          return;
        }

        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);
        });

        const firstCartItem = this.querySelector('.cart-item:first-child');
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);

        errors.innerHTML = '';
        errors.hidden = true;
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;
        console.log(error); // eslint-disable-line

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'free-shipping-notice',
          section: 'free-shipping-notice',
          selector: '.free-shipping-notice'
        }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          }
        ];
      } else {
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary').dataset.section,
            selector: '.cart__summary'
          }
        ];
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     */
    updateLiveRegions() {
      this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  customElements.define('cart-items', CartItems);
}
